export default {
  name: { id: 'name' },
  licenseeList: { id: 'licensee_list' },
  editLicensee: { id: 'edit_licensee' },
  removeLicensee: { id: 'remove_licensee' },
  visibleInUi: { id: 'visible_in_ui' },
  dateUpdated: { id: 'date_updated' },
  createButton: { id: 'create_button' },
  cancel: { id: 'cancel' },
  deleteLicenseeMessage: { id: 'delete_licensee_application_message' },
}
